const skills = [
    {
        name: 'Frontend Development',
        icon: 'code',
        skillSet : [
            {
                title: 'HTML',
                rate: '80%'
            },
            {
                title: 'CSS',
                rate: '60%'
            },
            {
                title: 'JavaScript',
                rate: '70%'
            },
            {
                title: 'React',
                rate: '60%'
            }
        ]
    },
    {
        name: 'C/C++ Development',
        icon: 'desktop_windows',
        skillSet : [
            {
                title: 'C Language',
                rate: '90%'
            },
            {
                title: 'C++',
                rate: '80%'
            }
        ]
    },
    {
        name: 'Backend Development',
        icon: 'dns',
        skillSet : [
            {
                title: 'Node JS',
                rate: '70%'
            },
            {
                title: 'Express',
                rate: '60%'
            },
            {
                title: 'Mongo DB Atlas',
                rate: '50%'
            }
        ]
    }
];
export default skills;